import React, { useState } from 'react'
import { Classes, Dialog } from '@blueprintjs/core'
import { Toaster, Button, Icon } from '@ui'
import api, { IFloorMapSpace, IEmployee } from '@api'
import { ApolloError } from 'apollo-boost'
import css from './adminFloorPlan.module.scss'
import MultiSelectComponent from '@ui/selects/MultiSelectComponent'
import { EmployeeItem } from '@ui/selects/EmployeeSelect'
import cx from 'classnames'

export interface EmployeeShareDialogProps {
  spaces: IFloorMapSpace[]
  assignmentPlanId: string
  setIsSharePopoverOpen: (para: boolean) => void
  isSharePopoverOpen: boolean
  employeeList: IEmployee[]
  setemployeeList: (employees: IEmployee[]) => void
}

export default function EmployeeShareDialog({
  spaces,
  assignmentPlanId,
  setIsSharePopoverOpen,
  isSharePopoverOpen,
  employeeList,
  setemployeeList,
}: EmployeeShareDialogProps) {
  const [btnDisabled, setBtnDisabled] = useState(true)

  const onChange = (employees: IEmployee[], param: any) => {
    if (param.status === 'add') {
      setemployeeList(employees)
      setBtnDisabled(false)
    } else {
      setemployeeList([...employeeList.filter((x) => x.id !== param.id)])

      if (employeeList.length <= 1) {
        setBtnDisabled(true)
      }
    }
  }

  const onClearAll = () => {
    setemployeeList([])
    setBtnDisabled(true)
  }

  return (
    <>
      <Dialog
        isOpen={isSharePopoverOpen}
        style={{ width: '560px', position: 'relative' }}
        transitionDuration={200}
        isCloseButtonShown={true}
        canOutsideClickClose={false}
        title={''}
        onClose={() => setIsSharePopoverOpen(false)}
      >
        <div className={Classes.DIALOG_HEADER}>
          <div className={css.shareSpaceHeader}>
            <Icon light name="share-alt" className={'fa-light'} />
            <div style={{ marginLeft: 20 }}> Share Space </div>
          </div>
        </div>
        <div className={Classes.DIALOG_BODY}>
          <div style={{ marginTop: 20 }}>
            {spaces.map((space, i) => (
              <div key={i} className={css.share_space_code}>
                <p> Seat Number {space.externalId}</p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 20 }}>
            <h5>Recipient:</h5>
          </div>
          <div style={{ marginTop: 10 }}>
            <MultiSelectComponent
              title="Recipient"
              multi
              values={employeeList || []}
              list={api.employee.search}
              icon={<Icon light name="envelope" className={cx('fa-light', css.envelopeIcon)} />}
              itemRenderer={EmployeeItem}
              onChange={onChange}
              onClear={onClearAll}
            />
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER} style={{ marginTop: 10 }}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              className={css.cancel_btn}
              disabled={false}
              text="Cancel"
              onClick={() => setIsSharePopoverOpen(false)}
            />
            <Button
              className={css.primary_btn}
              disabled={btnDisabled}
              autoFocus
              loading={false}
              text="Share"
              onClick={() => {
                if (spaces && employeeList.length > 0) {
                  const spacesIds = spaces.map((key) => {
                    return key.id
                  })
                  const receipientIds = employeeList.map((key) => {
                    return key.id
                  })
                  api
                    .shareSpace({
                      spaceIds: spacesIds,
                      recipients: receipientIds,
                      assignmentPlanId,
                    })
                    .then(() =>
                      Toaster.success({
                        message: 'Email notification sent',
                      })
                    )
                    .catch((error: ApolloError) => {
                      Toaster.fail({ error })
                    })
                  setIsSharePopoverOpen(false)
                }
              }}
            />
          </div>
        </div>
      </Dialog>
    </>
  )
}
